import config from '../../../config/config';
import actionTypes from './actionTypes';

const { REQUEST_TRANSCRIPTIONS, RECEIVE_TRANSCRIPTIONS, SERVER_ERROR_OCCURRED, RESET_SEARCH } = actionTypes;

export function fetchTranscriptions(token, forTranscriptions = false, searchObject = null) {
  return function(dispatch) {
    let queryString = '';
    if (searchObject) {
      queryString = Object.keys(searchObject).map(key => key + '=' + searchObject[key]).join('&');
    }
    dispatch({ type: REQUEST_TRANSCRIPTIONS });
    return fetch(`${config.URI}/api/v1/room_recordings?transcriptions=${forTranscriptions}&${queryString}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          // sort the recordings based on start time
          let roomRecordings = res.data.room_recordings.sort((a, b) => new Date(parseInt(b.recording_started_at) * 1000) - new Date(parseInt(a.recording_started_at) * 1000));
          dispatch({ type: RECEIVE_TRANSCRIPTIONS, roomRecordings });
        } else if (res.errors) {
          console.error(res.errors);
        }
      })
      .catch((error) => {
        console.error(error)
      });
  };
}

export function resetSearch() {
  return function(dispatch) {
    dispatch({ type: RESET_SEARCH });
  }
}



// WEBPACK FOOTER //
// src/routes/Transcriptions/actions/index.js